import type React from 'react';

export const AddEventListenerIfNotPresent = (selector: string, type: string, callback: () => void) => {
  const element = document?.querySelector(selector);

  if (element?.getAttribute('listener') !== 'true') {
    element?.addEventListener(type, callback);
    element?.setAttribute('listener', 'true');
  }
};

export const preventEvents = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
  e.stopPropagation();
};
